import { SERVICEACCOUNT_MESSAGES } from "../messages.js";
import { ClientMessage, TestResult } from "../objects.js";
import { startTestServiceAccount } from "../serviceAccountsUtils/testAndClient.js";
import { decryptAES128, isValid, waitSeconds } from "../utilitiesmodule.js";

export async function testServiceAccount(serviceAccount, pc) {
	this.$root.$emit("sendClientMessage", ClientMessage.wait("Test in progress", null, "testserviceaccount"), "testserviceaccount");
	var sendMsg = true;
	if (serviceAccount.crypted) {
		//I seguenti campi arrivano cryptati, ma per utilizzarli, li decripto
		serviceAccount.password = [undefined, null, ""].includes(serviceAccount.password) ? serviceAccount.password : decryptAES128(serviceAccount.password);
		serviceAccount.client_secret = [undefined, null, ""].includes(serviceAccount.client_secret) ? serviceAccount.client_secret : decryptAES128(serviceAccount.client_secret);
		serviceAccount.token = [undefined, null, ""].includes(serviceAccount.token) ? serviceAccount.token : decryptAES128(serviceAccount.token);
		serviceAccount.refresh_token = [undefined, null, ""].includes(serviceAccount.refresh_token) ? serviceAccount.refresh_token : decryptAES128(serviceAccount.refresh_token);
		serviceAccount.crypted = false;
	}

	var response = TestResult.getFailed();
	try {
		prepare_test: {

			//Cloud
			if (serviceAccount.type.isCloud() || serviceAccount.type.isMicrosoft365()) {
				var realLastRoute = sessionStorage.getItem('lastRoute');
				//Alcune richieste token necessitano di un reinderezzamento su /
				sessionStorage.setItem('lastRoute', "/");
				response = await startTestServiceAccount(serviceAccount);
				sessionStorage.setItem('lastRoute', realLastRoute);

				break prepare_test;
			}


			//Raggruppo tutti i service account i cui test necessitano di una chiamata socket, quindi di un pc
			//Questo pc sarà:
			// - this.$session.getRoomPC() se sono dentro un computer
			// - pc passato se + stato passato un computer con cui eseguire il test
			// - serviceAccount.options.lastTestPC (è un id di un computer) se è stato salvato nel service account ed è attualmente connesso
			if (isValid(this.$session.getRoomPC()))
				pc = this.$session.getRoomPC();
			else if (isValid(pc))
				await this.$root.socket("SETPC", pc);
			else if (isValid(serviceAccount.options.lastTestPC) && this.connectionsStates[serviceAccount.options.lastTestPC]) {
				pc = this.$session.getPCWithID(serviceAccount.options.lastTestPC);
				await this.$root.socket("SETPC", pc);
			} else {
				break prepare_test;
			}

			//Il feedbackMessage proviene dall'agent, quindi non devo inviarlo da qui
			sendMsg = false;

			test_by_case: {

				//EXCHANGE ON PREMISES
				if (serviceAccount.type.isExchangeOnPremises()) {
					//ATTENZIONE! NON IMPLEMENTATO SULL'AGENT!!
					response.ok = await this.$root.socket("testserviceaccount", serviceAccount);
					response.okNumber = response.ok ? 1 : 0;

					if (response.ok && isValid(serviceAccount.id)) {
						response.list = await this.$root.socket("GetExchangeMailboxes", serviceAccount.id);
						response.ok = response.list != null;
						response.okNumber = response.ok ? 1 : 0;
					}
					break test_by_case;
				}


				sendMsg = false;
				//FTP + NETWORK + ESXI + DATABASE + EMAIL
				response = await this.$root.socket("testserviceaccount", serviceAccount);
				break test_by_case;

			}
		}
	} catch (e) {
		console.writeError(e);
		response = TestResult.getFailed();

	}

	if (this.$session.getRoomPC() == null) {
		await this.$root.socket("SETPC", null);
	}

	if (response.serviceAccount && isValid(pc)) {
		response.serviceAccount.options.lastTestPC = pc.id;
	}

	if (response.ok && isValid(response.serviceAccount.id)) {
		this.$api.editServiceAccount(response.serviceAccount);
		this.$session.editServiceAccount(response.serviceAccount);
	}

	if (sendMsg) {
		this.$root.$emit("sendClientMessage",
			response.ok
				? ClientMessage.success(SERVICEACCOUNT_MESSAGES.TEST_OK, { 0: serviceAccount.name }, "testserviceaccount", false)
				: ClientMessage.error(SERVICEACCOUNT_MESSAGES.TEST_FAILED, { 0: serviceAccount.name }, "testserviceaccount", false),
			"testServiceAccount"
		);
	}


	return response;

}

export async function saveServiceAccount(serviceAccount) {
	var newServiceAccount = isValid(serviceAccount.id) ?
		await this.$api.editServiceAccount(serviceAccount) :
		await this.$api.createServiceAccount(serviceAccount);

	if (!isValid(newServiceAccount)) {
		return false;
	}

	if (!isValid(serviceAccount.id)) {
		this.$session.addServiceAccount(newServiceAccount);
	} else {
		this.$session.editServiceAccount(newServiceAccount);
	}

	this.$root.$emit("REFRESHSERVICEACCOUNTS", newServiceAccount);
	// Do il tempo all'utente di visualizzare il messaggio di buona riuscita dell'operazione
	await waitSeconds(2);
	this.$root.$emit('CLOSESERVICEACCOUNTDIALOG');
	return true;
}

export async function duplicateServiceAccount(idSA_or_SA) {
	var serviceAccount;
	if (typeof idSA_or_SA == "string") {
		serviceAccount = this.$session.getServiceAccountWithID(idSA_or_SA);
	} else {
		serviceAccount = idSA_or_SA
	}

	if (serviceAccount.crypted) {
		//I seguenti campi arrivano cryptati, ma per utilizzarli, li decripto
		serviceAccount.password = [undefined, null, ""].includes(serviceAccount.password) ? serviceAccount.password : decryptAES128(serviceAccount.password);
		serviceAccount.client_secret = [undefined, null, ""].includes(serviceAccount.client_secret) ? serviceAccount.client_secret : decryptAES128(serviceAccount.client_secret);
		serviceAccount.token = [undefined, null, ""].includes(serviceAccount.token) ? serviceAccount.token : decryptAES128(serviceAccount.token);
		serviceAccount.refresh_token = [undefined, null, ""].includes(serviceAccount.refresh_token) ? serviceAccount.refresh_token : decryptAES128(serviceAccount.refresh_token);
		serviceAccount.crypted = false;
	}

	var newServiceAccount = serviceAccount
	newServiceAccount.id = null;

	var self = this;

	var dialogID = Math.floor(100000 + Math.random() * 900000).toString();

	this.$root.$on(dialogID, async newName => {
		var closeDialog = true, ok;
		try {
			if (newName == null || newName == '') {
				return;
			}
			newServiceAccount.name = newName;
			ok = await saveServiceAccount.call(this, newServiceAccount);

			if (ok) {
				return;
			}

			//Tengo aperta la dialog per consentire all'utente di riprovare
			closeDialog = false;

		} finally {
			if (!closeDialog)
				return;

			self.$root.$off(dialogID);
			self.$router.removeHash(); // prototype implementato in main.js
			if ($("#newText") && $("#newText").parent() && $("#newText").parent().parent()) {
				Metro.dialog.close($("#newText").parent().parent());
			}
			//location.reload();

		}
	});

	//Avvio la richiesta che mi risponderà con un $emit
	var dialogTitle = this.$t("Duplicate Service Account \"{0}\"", { 0: serviceAccount.name });
	var dialogContent = this.$t("Insert a name for the new service account");//this.$t('Are you sure to duplicate repository \"{0}\"? ', { 0: repository.name });
	var placeholder = this.$t("Insert a name");
	var initialValue = serviceAccount.name + " (DUPLICATED)";

	//Avvio la richiesta che mi risponderà con un $emit
	this.$root.openInsertTextDialog(dialogID, dialogTitle, dialogContent, placeholder, initialValue, 50);

}

export async function deleteServiceAccount(idSA_or_SA) {
	var self = this;
	var serviceAccount;
	if (typeof idSA_or_SA == "string") {
		serviceAccount = this.$session.getServiceAccountWithID(idSA_or_SA);
	} else {
		serviceAccount = idSA_or_SA;
	}
	var dialogID = Math.floor(100000 + Math.random() * 900000).toString();
	var dialogTitle = this.$t("Delete Service Account \"{0}\"", { 0: serviceAccount.name });
	var dialogContent = this.$t('Are you sure to delete service account \"{0}\"?', { 0: serviceAccount.name });

	this.$root.$on(dialogID, async ok => {
		var closeDialog = true;
		try {
			if (!ok) {
				return;
			}

			ok = await self.$api.deleteServiceAccount(serviceAccount.id, serviceAccount.name);

			if (!ok) {
				closeDialog = false;
				return;
			}

			self.$session.deleteServiceAccount(serviceAccount.id);
			this.$root.$emit("REFRESHSERVICEACCOUNTS");
			// Do il tempo all'utente di visualizzare il messaggio di buona riuscita dell'operazione
			await waitSeconds(2);

		} finally {
			if (closeDialog) {
				self.$root.$off(dialogID);

				self.$root.$emit('CLOSESERVICEACCOUNTDIALOG');
				self.$router.removeHash(); // prototype implementato in main.js
				//location.reload();
			}
		}
	});

	//Avvio la richiesta che mi risponderà con un $emit
	this.$root.openYesNoDialog(dialogID, dialogTitle, dialogContent)

}


export async function disconnectServiceAccount(serviceAccount) {
	if (serviceAccount.type == this.$ONEServiceType.Network && serviceAccount.options.accountSessionId != "") {
		this.$root.socket("disconnectnetwork", serviceAccount.options.accountSessionId);
		serviceAccount.options.accountSessionId = "";
		saveServiceAccount.call(this, serviceAccount);
		return;
	}

	if (serviceAccount.type == this.$ONEServiceType.FTP && serviceAccount.options.accountSessionId != "") {
		this.$root.socket("disconnectftp", serviceAccount.options.accountSessionId);
		serviceAccount.options.accountSessionId = "";
		saveServiceAccount.call(this, serviceAccount);
		return;
	}
}

export function getSARootPath(sa) {
	if (!sa)
		return "";

	if (sa.type == this.$ONEServiceType.Network) {
		return sa.options.path;
	}

	if (sa.type == this.$ONEServiceType.FTP) {
		return sa.url;
	}

	return "";
}
